import { Component } from "@angular/core";

@Component({
  standalone: true,
  selector: "o-empty",
  template: ""
})
/**
 * Empty component.
 * Component is mandatory for every route, but nothing to do here.
 */
export class EmptyComponent {}
